export const AccessTokenAuth = {
    HeaderName: "Authorization",
    GetHeaderValue: () => {
        const authValue = localStorage.getItem(AccessTokenAuth.HeaderName);
        return (`token ${authValue}`);
    },
    TrySaveAccessToken: (headerString) => {
        let token = undefined;

        if (headerString !== undefined) {
            const splitHeaderString = headerString.split(' ');
            if (splitHeaderString.length === 2) {
                token = splitHeaderString[1];
                localStorage.setItem(AccessTokenAuth.HeaderName, token);
                return true;
            }
        }

        return false;
    },

    DeleteAccessToken: () => {
        localStorage.removeItem(AccessTokenAuth.HeaderName);
    }
};
